import { Box } from '@mui/material';
import { Link } from 'react-router-dom';

function Breadcrumb({ userData, portal, location, page, partNumber }) {
  return (
    <>
      <Box>
        {location &&
          location?.map((loc, i) => (
            <>
              {loc.to ? (
                <Link key={i} to={`${loc?.to}`}>
                  <span
                    className="breadcrumb-item"
                    style={{
                      fontWeight: 400,
                      fontSize: '0.875rem'
                    }}
                  >
                    {`${loc?.location}`}
                  </span>
                </Link>
              ) : (
                <span
                  className="breadcrumb-item"
                  style={{
                    fontWeight: 400,
                    fontSize: '0.875rem'
                  }}
                >
                  {` ${loc?.location} `}
                </span>
              )}
            </>
          ))}{' '}
        <span
          className="breadcrumb-item"
          style={{
            fontWeight: 400,
            fontSize: '0.875rem'
          }}
        >
         
          {userData &&
            ` / ${
              userData?.customerName
                ? userData?.customerName
                : 
              (userData?.supplierName 
                ? userData?.supplierName
                : userData?.firstName + ' ' + userData?.lastName)
            }`}
            
          {page && ` / ${page}`}
          {portal && ` / ${portal.customerNames}`}

          {partNumber && ` / ${partNumber}`}
        </span>
      </Box>
    </>
  );
}

export default Breadcrumb;
